import find from 'lodash/find';
import CreatePO from './packages/CreatePO/components/CreatePO';

export const CREATE_PO_ROUTE = '/receive-inventory/create-po';

export default {
    name: 'createPo',
    before: [],
    after: [],
    setup: (app) => {
        const route = CREATE_PO_ROUTE;
        const label = 'Create PO';
        const permission = 'purchase orders.index';

        const receiveInventoryRoute = app.routes.getItem('receiveInventoryMain');
        if (receiveInventoryRoute) {
            const receiveInventoryRouteProps = receiveInventoryRoute.props;
            const setReceiveInvetoryOptions = (options) => {
                if (!find(options, ['id', 'createPO'])) {
                    options.push({
                        id: 'createPO',
                        component: CreatePO,
                        title: 'Create PO',
                        order: 11,
                    });
                }

                return options;
            };
            receiveInventoryRoute.props = (state) => ({
                ...receiveInventoryRouteProps(state),
                setReceiveInvetoryOptions,
                createPOPoRoute: CREATE_PO_ROUTE,
            });
            app.routes.changeItem('receiveInventoryMain', receiveInventoryRoute);
        }

        app.routes.addItem('createPoRoute', {
            path: route,
            title: label,
            permission,
            props: () => ({
                productDetailsPageRoute: '/products/overview',
                receiveInvetoryMainPageRoute: '/receive-inventory/main',
            }),
            loader: () => import('./packages/CreatePO/core'),
        });
    },
};
